class Icon {
    constructor(iconName, iconClasses) {
        this.iconName = iconName;
        this.spriteUrl = '/areas/public/clientapp/dist/icons.svg?v=1.1.17.0';
        this.iconClasses = iconClasses ? iconClasses : '';
    }
    render() {
        return this.generateIconHtml(this.iconName, this.spriteUrl, this.iconClasses);
    }
    generateIconHtml(iconName, spriteUrl, iconClasses) {
        return `
                    <span class="icon ">
                        <use xlink:href="${spriteUrl}#${iconName}"></use>
                    </span>`;

    }
}

export default Icon;